module.exports = __webpack_public_path__ + "img/KarbalaAirport1.0effcb4d.jpg";